<template>
    <div id="step_component_wrapper">
        <div class="slot-content">

            <div class="input-group">
                <span class="input-group-addon" :class="{'error_highlight': machineValid != 0}"><i :class="$root.icons.search_btn" aria-hidden="true"></i></span>
                <input class="form-control" id="machine_selector"  :class="{'error_highlight': machineValid != 0}" type="text" 
                v-model="machineInput" :placeholder="machineLabels[machineValid]">
            </div>
            <div v-if="renderModelInput" class="input-group" style="margin-top: 25px;">
                <span class="input-group-addon" :class="{'error_highlight': modelValid != 0}"><i :class="$root.icons.search_btn" aria-hidden="true"></i></span>
                <input class="form-control" id="model_selector" name="model" :class="{'error_highlight': modelValid != 0}" type="text" 
                v-model="modelInput" :placeholder="modelLabels[modelValid]">
            </div>

        </div>
        <div class="slot-button">
            <button v-if="!backTo1Allowed" class="btn btn-danger" @click="$root.logout()">Logout</button>
            <button v-else class="btn btn-danger" @click="$emit('backward')">{{$Jed.firstUpperTranslate('back', null)}}</button>
            <button class="btn btn-default" style="width: auto;" @click="skip">{{$Jed.firstUpperTranslate('skip', null)}}</button>

            <button v-if="formFilled" 
            class="btn btn-primary-default" @click="check">{{$Jed.firstUpperTranslate('confirm', null)}}</button>

            <popover-alert v-else effect="fade" placement="top" 
                :title="!machineFilled ? machineLabels[3] : modelLabels[3]" 
                :content="$Jed.firstUpperTranslate('you are being redirected to the %1$s menu', null, {string: this.$Jed.translate('selezione %1$s', null, {key: 'index'})})" 
                :ok="skip" 
                :popoverStyle="{ right:'10px', 'max-width': '200px', width: '100%', 'font-size': 'small', height: 'max-content', bottom: '60px'}" 
                :arrowStyle="{left:'75%'}" :textStyle="{color: '#222'}" classes="autoleft autotop" >
                    <button class="btn btn-primary-default" style="margin: 0px 5px">{{$Jed.firstUpperTranslate('confirm', null)}}</button>
            </popover-alert>
        </div>
    </div>
</template>
<script>
import PopoverAlert from '../../dynamic/popoverWrapper/Popover.vue'
import { eventBus } from "../../../eventbus.js";

    export default {
        props: {
            backTo1Allowed: {
               type: Boolean,
               default: false
            }
        },
        components: {
            PopoverAlert
        },
        data: function(){
            return {
                renderModelInput: this.$Behaviors.requestMachineModel,
                machineInput: null,
                modelInput: null,

                machineValid: 0,
                modelValid: 0,

                machineLabels: [
                    this.$Jed.firstUpperTranslate('insert %1$s to identify', null, {key: 'machine ID'}), 
                    this.$Jed.firstUpperTranslate('incorrect %1$s format', null, {key: 'machine ID'}), 
                    this.$Jed.firstUpperTranslate('%1$s unidentified', null, {key: 'machine ID'}, 'female'), 
                    this.$Jed.firstUpperTranslate('missing %1$s', null, {key: 'machine ID'}, 'female')
                ],
                modelLabels:  [
                    this.$Jed.firstUpperTranslate('insert %1$s to identify', null, {key: 'model'}), 
                    this.$Jed.firstUpperTranslate('incorrect %1$s format', null, {key: 'model'}), 
                    this.$Jed.firstUpperTranslate('%1$s unidentified', null, {key: 'model'}, 'male'), 
                    this.$Jed.firstUpperTranslate('missing %1$s', null, {key: 'model'}, 'male')
                ]
            }
        },
        computed: {
            formFilled: function(){
                return this.machineFilled && (!this.renderModelInput || this.modelFilled);
            },
            machineFilled: function(){
                return this.machineInput != null && this.machineInput != '';
            },
            modelFilled: function(){
                return this.modelInput != null && this.modelInput != '';
            }
        },
        methods: {
            forward: function(){
                console.log("forward");
            },
            backward: function(){
                if(this.backTo1Allowed){
                    this.$emit("forward", {step: 1})
                }
            },
            skip: function(){
                var parameters = {};
                parameters.functionName = "load_from_client_catalog_list";
                parameters.functionParameter = true;
                this.$emit('forward', parameters);
            },
            check: function(){
                var first = false;
                var second = true;

                //machineId (and opt. model) validation 
                if(this.$root.token.machineIdValidationExp && this.$root.token.machineIdValidationExp != ''){
                    try{
                        var reg_matricola = new RegExp(this.$root.token.machineIdValidationExp);
                        first = reg_matricola.test(this.machineInput)
                    }catch(err){console.log('Parsing Machine ID RegExp', err)}
                }
                
                if(this.renderModelInput){
                    second = false;
                    try{
                        var reg_modello = new RegExp(this.$root.token.modelIdValidationExp);
                        second = reg_modello.test(this.modelInput)
                    }catch(err){console.log('Parsing Model ID RegExp', err)}
                }
            
                if(first && second) {
                    var catalog_reference = null;
                  
                    this.$root.microservice({
                        "role": "authentication",
                        "cmd": "FindMachineId",
                        "params": {
                            "matricola": this.machineInput,
                            "idProdotto": this.modelInput,
                            "idCliente": this.$root.token.idCliente
                        }
                    }).then((response) => {
                        var b = response.body;
                        if(b.error){
                            alert(b.error)
                        }else{
                            var parameters = {};
                            parameters.override = { 
                                machineID: this.machineInput, 
                                modelID: this.modelInput ? this.modelInput : b.mod_of_mac, 
                                catalogo: b.cod
                            };
                        
                            if(b.error == null && b.machineFound){
                                //forward step menu
                                parameters.step = 4;
                                this.$emit('forward', parameters);
                            } else if(b.error == null && this.renderModelInput){
                                if(this.$Behaviors.machineRegistrationAllowed){
                                    parameters.step = 3; 
                                    this.$emit('forward', parameters);
                                } else {
                                    this.machineInvalid(2);
                                }
                            } else {
                                this.machineInvalid(2);
                                this.modelInvalid(2);
                            }
                        }
                    })
                    .catch(err => {
                        console.log(err);
                        var msg = err && err.body && err.body.error ? err.body.error : ''
                        loading_screen.finish();
                        eventBus.$emit('alert', {
                            message: "Application caught an error <br> <h5>Details: " + "authentication.FindMachineId - " + msg +'</h5>', 
                            type: "error",
                            action: ''
                        })
                    })	
                    

                } else {
                    if(!first){
                        this.machineInvalid(1);
                    } else {
                        this.modelInvalid(1)
                    }
                }
            },
            machineInvalid: function(lev){
                this.machineInput = null;
                this.machineValid = lev;
                $("#machine_selector").focus();
            },
            modelInvalid: function(lev){
                this.modelInput = null;
                this.modelValid = lev;
                $("#model_selector").focus();
            }
        }
    }
</script>
<style scoped>
div.input-group > span {
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
}
div.input-group > input {
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
}
.error_highlight {
    color: #a94442;
    background-color: #f2dede;
    border-color: #ebccd1;
}
</style>


// WEBPACK FOOTER //
// src/components/loader/steps/IdentificazioneProdotto.vue?4a560766